import { render } from "./Redesociales.vue?vue&type=template&id=159d36cd&scoped=true"
import script from "./Redesociales.vue?vue&type=script&lang=js"
export * from "./Redesociales.vue?vue&type=script&lang=js"

import "./Redesociales.vue?vue&type=style&index=0&id=159d36cd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-159d36cd"

export default script